$(function() {
  $(document).on('click', 'a[data-dismiss=\'popover\']', function(event) {
    $(this).closest('.popover').removeClass('in');
    event.preventDefault();
  });
});
